import { Loader } from '@googlemaps/js-api-loader';

import { useAppStore } from '@src/store';

/**
 * @method GetCoordinates
 *
 * Caller supplies a zip code and this function makes an API call
 * to a google service and responds with lat/long if valid zip
 * code was provided.
 *
 * @param zipCode {string} - 5 digits enforced
 *
 */
const GetCoordinates = (zipCode: string): Promise<{ lat: number; lng: number }> => {
	return new Promise((resolve, reject) => {
		try {
			if (!/^(\d{5})$/.test(zipCode)) {
				throw new Error('invalid zipCode supplied to services/GetCoordinates()');
			}
			const loader = new Loader({
				apiKey: useAppStore.getState().googleMapApiKey,
				libraries: ['geocoding'],
			});
			loader
				.importLibrary('geocoding')
				.then(() => {
					const geocoder = new google.maps.Geocoder();
					const componentRestrictions = { postalCode: zipCode };
					geocoder.geocode({ componentRestrictions }, (results, status) => {
						if (status === 'OK' && results?.[0]) {
							resolve({
								lat: results[0].geometry.location.lat(),
								lng: results[0].geometry.location.lng(),
							});
						} else {
							reject(new Error('no data returned for zip from services/GetCoordinates()'));
						}
					});
				})
				.catch((e) => {
					if (e instanceof Error) {
						reject(e);
					} else {
						reject(new Error(String(e)));
					}
				});
		} catch (e) {
			if (e instanceof Error) {
				reject(e);
			} else {
				reject(new Error(String(e)));
			}
		}
	});
};

export default GetCoordinates;
